import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Notification, NotificationImportance, NotificationStatus } from 'src/graphql/generated/schema';
import { shortLocalDate } from '../../../helpers/date-helper';
import { CheckboxCustomEvent } from '@ionic/angular';

export interface ICheckboxToggleEvent {
  id: string;
  status: NotificationStatus;
}

@Component({
  selector: 'alert-card',
  templateUrl: './alert-card.component.html',
  styleUrls: ['./alert-card.component.scss']
})
export class AlertCardComponent {
  @Input()
  alert!: Notification;

  @Output() onCheckboxToggled: EventEmitter<ICheckboxToggleEvent> = new EventEmitter();

  public get severityLabel(): string {
    switch (this.alert.importance) {
      case NotificationImportance.Critical: return 'Critical';
      case NotificationImportance.Medium: return 'Medium';
      default: return 'Low';
    }
  }

  public get severityClass(): string {
    switch (this.alert.importance) {
      case NotificationImportance.Critical: return 'c';
      case NotificationImportance.Medium: return 'm';
      default: return 'l';
    }
  }

  public formatDate(originalDate?: string) {
    return shortLocalDate(originalDate);
  }

  public isNotRead(): boolean {
    return this.alert.status === NotificationStatus.NotRead;
  }

  public toggleAlertReadState(e: CheckboxCustomEvent){
    this.onCheckboxToggled.emit({
      id: this.alert.id,
      status: this.alert.status
    })
  }
}
